module.exports = __webpack_public_path__ + "static/media/header_help.0bda49d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_help.jpg
// module id = 957
// module chunks = 0